import React from 'react';
import { FaMinusCircle, FaSortDown, FaSortUp } from 'react-icons/fa';
import { TagInput, TagInputType } from '../TagInput/TagInput';
import "./SSKeyValueInput.scss";
import UserVariablesDropdown from '../Dropdowns/UserVariablesDropdown/UserVariablesDropdown';

interface Props {
  title?: string;
  arrayName:string 
  arrayIndex:number
  moveItemInArray(arrayName:string, itemIndex:number, up:boolean) 
  delete(arrayName:string, itemIndex:number) 
  onChange(e:any) 
  isValueAVariable:boolean
  valueValue:any 
  keyKey:any
  valuePlaceholder?:any
  keyValue?:any
  keyPlaceholder?:any
  valueKey?:any
}
export default class SSKeyValueInput extends React.Component<Props>{
  constructor(props) { super(props);
    this.deletePressed = this.deletePressed.bind(this)
    this.upPressed    = this.upPressed.bind(this)
    this.downPressed  = this.downPressed.bind(this)
  }
  upPressed()     { this.props.moveItemInArray(this.props.arrayName, this.props.arrayIndex, true);  }
  downPressed()   { this.props.moveItemInArray(this.props.arrayName, this.props.arrayIndex, false); }
  deletePressed() { if (this.props.delete) { this.props.delete(this.props.arrayName, this.props.arrayIndex);   }}

  render() {
        const moveControls = (!this.props.moveItemInArray) ? null : <div className="orderControls">
                    <div className="orderControl" onClick={this.downPressed}><FaSortUp /></div>
                    <div className="orderControl"   onClick={this.upPressed}><FaSortDown /></div>
                  </div>;


        const keyName = this.props.arrayName + "." + this.props.arrayIndex + "." + this.props.keyKey;

        const valueName = this.props.arrayName + "." + this.props.arrayIndex + "." + this.props.valueKey;


        const value = (this.props.isValueAVariable) ? <UserVariablesDropdown
                                                        onChange={this.props.onChange}
                                                        name={valueName}
                                                        value={this.props.valueValue}
                                                        /> : <TagInput 
                                                        value={this.props.valueValue}
                                                        onChange={this.props.onChange}
                                                        name={valueName}
                                                        placeholder={(this.props.valuePlaceholder) ? this.props.valuePlaceholder : "Value..."}
                                                        type={TagInputType.SingleLine}
                                                        
                                                     />
                                                        
                                                        
                                        
                                                     


        return <div className="SSKeyValueInput">
                <div className="titleRow">
                  {moveControls}
                  <div className="title">{(this.props.title) ? this.props.title : "Key / Value"}</div>
                  <div className="deleteButton" onClick={this.deletePressed}><FaMinusCircle/></div>
                </div>
                <div className="inputsRow">


                <TagInput 
                  value={this.props.keyValue}
                  onChange={this.props.onChange}
                  name={keyName}
              placeholder={(this.props.keyPlaceholder) ? this.props.keyPlaceholder : "Key..."}
              type={TagInputType.SingleLine}
              />


                   {value}


                </div>
        </div>;
     }
};
